export default __webpack_public_path__ + "static/media/Mask Group 8.8e582281.png";